/* Copyright Verge Technologies 2018
 * @file specials.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React from 'react';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { EVENTS_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';

const Events = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <div className="page-heading heading-specials">Events</div>
      <Query query={EVENTS_QUERY} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div className="content-list-container special-list">
              <ul style={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}>
                {data.getEvents.map((special) => {
                  return (
                    <li>
                      <div className="image-block">
                        <img src={special.background_image} alt="special" />
                      </div>
                      <div className="content-block">
                        <h2>{special.test}</h2>
                        <p>
                          {special.short_description}
                        </p>
                      </div>
                      <div className="control">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={special.link}
                          className="button button-green"
                        >
                          View details
                        </a>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        }}
      </Query>
      <Footer />
    </div>
  );
};

export default Events;



// WEBPACK FOOTER //
// ./src/pages/events/events.page.js